import React from "react";
import { Check, Minus } from "lucide-react";
import { keterangan } from "@/lib/progres";

// v2.20 (owner 2026-10-26): Desain -> Revisi -> ACC customer -> Produksi -> Selesai, from the server
// (acc_service.progres). Five dots on one row (the labels may wrap on a phone — never a sideways scroll).
const TITIK = {
  SELESAI: "bg-emerald-600 border-emerald-600 text-white",
  LEWAT: "bg-white border-emerald-600 text-emerald-700",
  JALAN: "bg-soq-biru border-soq-biru text-white ring-4 ring-soq-biru/20",
  BELUM: "bg-white border-slate-300 text-slate-400",
};

export default function GarisProgres({ progres, untuk = "staf", testid = "garis-progres", kecil = false }) {
  if (!progres) return null;
  if (progres.dibatalkan) return <div data-testid={testid} className="rounded-lg bg-slate-100 px-3 py-2 text-sm font-semibold text-slate-600">Pesanan dibatalkan</div>;
  const n = progres.langkah.length;
  return (
    <ol data-testid={testid} aria-label="Progres pesanan" className="grid gap-1" style={{ gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))` }}>
      {progres.langkah.map((l, i) => {
        const k = keterangan(l, untuk);
        return (
          <li key={l.kode} data-testid={`${testid}-${l.kode}`} data-status={l.status} aria-current={l.kode === progres.tahap ? "step" : undefined}
            className="relative flex flex-col items-center text-center">
            {i > 0 && <span aria-hidden className={`absolute top-3 right-1/2 h-0.5 w-full ${l.status === "BELUM" ? "bg-slate-300" : "bg-emerald-600"}`} style={{ zIndex: 0 }} />}
            <span className={`relative z-10 flex h-6 w-6 items-center justify-center rounded-full border-2 text-[11px] font-bold ${TITIK[l.status] || TITIK.BELUM}`}>
              {l.status === "SELESAI" ? <Check size={14} strokeWidth={3} /> : l.status === "LEWAT" ? <Minus size={14} strokeWidth={3} /> : i + 1}
            </span>
            <span className={`mt-1 leading-tight font-semibold ${kecil ? "text-[10px]" : "text-[11px] sm:text-xs"} ${l.status === "JALAN" ? "text-soq-biru-tua" : l.status === "BELUM" ? "text-slate-500" : "text-slate-800"}`}>{l.label}</span>
            {k && !kecil && <span className="mt-0.5 text-[10px] sm:text-[11px] leading-tight text-slate-500">{k}</span>}
          </li>
        );
      })}
    </ol>
  );
}
